var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22282 14.6545C5.61335 14.264 6.24651 14.264 6.63704 14.6545L11.9999 20.0174L17.3628 14.6545C17.7533 14.264 18.3865 14.264 18.777 14.6545C19.1676 15.0451 19.1676 15.6782 18.777 16.0687L12.707 22.1387C12.5195 22.3263 12.2651 22.4316 11.9999 22.4316C11.7347 22.4316 11.4804 22.3263 11.2928 22.1387L5.22282 16.0687C4.8323 15.6782 4.8323 15.0451 5.22282 14.6545Z",
    fill: "#9091A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.43164C12.5523 3.43164 13 3.87936 13 4.43164V21.2616C13 21.8139 12.5523 22.2616 12 22.2616C11.4477 22.2616 11 21.8139 11 21.2616V4.43164C11 3.87936 11.4477 3.43164 12 3.43164Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.79af9b88d68c8bc39be7809433ed943c.svg";
export { ForwardRef as ReactComponent };